import React from 'react'

const Pages = () => {
  return (
    <div>
      <h1>pages</h1>
    </div>
  )
}

export default Pages
